import { transformHtmlContent } from './contentTransforms';

export const saveContent = (content: string, widgetInstanceId: string) => {
    // console.log('Saving content:', content);

    // Transform font tags and colors to use CSS variables before saving
    const transformedContent = transformHtmlContent(content);
    // console.log('Transformed content:', transformedContent);

    // Try to access Redux store directly if available
    const store = (window as any).__REDUX_STORE__;
    if (store && store.dispatch) {
        try {
            if (store.getState && store.getState().templateEditor) {
                store.dispatch({
                    type: 'templateEditor/SAVE_COMPONENT_PROPERTIES',
                    payload: {
                        id: widgetInstanceId,
                        properties: { editorHtml: transformedContent },
                    },
                });
            } else {
                throw new Error('Template editor not available');
            }
        } catch (error) {
            console.log('Redux dispatch failed, using custom event:', error);
            emitUpdateEvent(transformedContent, widgetInstanceId);
        }
    } else {
        // console.log('Redux store not found, using custom event');
        emitUpdateEvent(transformedContent, widgetInstanceId);
    }
};

export const emitUpdateEvent = (content: string, widgetInstanceId: string) => {
    const updateEvent = new CustomEvent('widgetPropertyUpdate', {
        detail: {
            widgetInstanceId: widgetInstanceId,
            properties: { editorHtml: content },
        },
    });
    window.dispatchEvent(updateEvent);

    if (window.parent && window.parent !== window) {
        window.parent.postMessage(
            {
                type: 'widgetPropertyUpdate',
                widgetInstanceId: widgetInstanceId,
                properties: { editorHtml: content },
            },
            '*'
        );
    }
};
